<template lang="pug">
.report
  v-stepper(
    v-model="el"
    vertical)
    v-stepper-step(
      :complete="el > 1"
      step="1") 轉帳或匯款至指定帳戶
    v-stepper-content(step="1")
      report-landing(@next="el = 2")
    v-stepper-step(
      :complete="el > 2"
      step="2") 填寫線上登錄表格
    v-stepper-content(step="2")
      report-user-creation-form(
        ref="form"
        @cancel="$router.push({ name: 'home' })"
        @submit-succeed="el = 3")
    v-stepper-step(
      :complete="el > 3"
      step="3") 完成付款
    v-stepper-content(step="3")
      v-card(
        max-width="578"
        color="primary")
        v-img(
          :src="beachImg"
          :aspect-ratio="2")
        v-card-title.white--text.headline 您的繳款資料已登錄成功。非常感謝您的支持！
        div.text-xs-center.py-3
          v-btn(
            color="white"
            :to="{ name: 'home' }") 回到首頁
</template>
<script>
import ReportLanding from "@/components/ReportLanding.vue";
import ReportUserCreationForm from "@/components/forms/ReportUserCreationForm.vue";
import errorParser from "@/utils/error";
import beachImg from "@/assets/images/beach.jpg";

export default {
  name: "Report",
  components: {
    ReportLanding,
    ReportUserCreationForm
  },
  data() {
    return {
      beachImg,
      el: 0
    };
  }
};
</script>
